<template>
  <div class="header-box">
    <!-- <SearchMeessagebox
      ref="fixSearch"
      :class="fixTop ? 'search-fix' : 'search-fixout'"></SearchMeessagebox> -->
    <Userinfo></Userinfo>
    <Search></Search>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data () {
    return {
      fixTop: false,
      isChecked: true,
      query: ''
    }
  },
  // props: ['flag', 'searchs'],
  components: {
    // Userinfo: () => import('./components/Userinfo'),
    SearchMeessagebox: () => import('@/components/public/SearchMeessagebox'),
    Userinfo: () => import('./components/RedesignUserinfo'),
    Search: () => import('./components/Search')
  },
  methods: {},
  watch: {},
  mounted () {
    document.addEventListener("scroll", () => {
      this.fixTop =
        document.documentElement.scrollTop > 770 && this.$route.path == "/";
      if (!this.fixTop) {
        // this.$refs.fixSearch.blur();
      } else {
        try {
          // this.$refs.fixSearch.$refs.searchBox.initQuery();
        } catch (error) {}
      }
    });
  },
  created () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  // @import "@/styles/variable.scss";
</style>
